export default __webpack_public_path__ + "static/media/bg-our-loans.cc88b560.png";